// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"91927301","408":"6765b7aa","419":"23270f78","424":"3392c4e8","504":"2d04fda8","606":"87ccb9da","787":"c98ebba2"}[chunkId] + ".chunk.js";
};